import moment from 'moment';

// Engagement surveys rotate through multiple themes, so the score only covers
// the full rotation once this many months of surveys have run.
export const ENGAGEMENT_RELIABLE_AFTER_MONTHS = 3;

const DAY_MS = 86_400_000;

// Days left before the engagement score covers a full theme rotation, counted
// from the first survey the workspace ever sent. Historical periods use the
// selected end-date; the current (still-open) period uses today so a future
// month-end does not hide or understate the ramp-up warning.
// Null outside the ramp-up: no survey yet, a period that ended before the very
// first survey (nothing was being measured, so there is nothing to count down
// to), or a period past the full rotation.
export const getEngagementReliabilityDaysRemaining = (
	firstSurveyAt: Date | null,
	endDate: Date,
	now: Date = new Date(),
): number | null => {
	if (!firstSurveyAt || firstSurveyAt > endDate) return null;

	const referenceDate = endDate > now ? now : endDate;

	const remaining = moment(firstSurveyAt)
		.add(ENGAGEMENT_RELIABLE_AFTER_MONTHS, 'months')
		.diff(referenceDate);

	if (remaining <= 0) return null;

	return Math.ceil(remaining / DAY_MS);
};
